import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import {
  ISignUpCountries,
  ISignUpCountryCatalogue,
  ISignUpCountryOption
} from '@core/models/sign-up.model';

@Injectable({
  providedIn: 'root'
})
export class SignUpCountryService {
  private readonly names = new Intl.DisplayNames(['en-GB'], { type: 'region' });
  private readonly order = new Intl.Collator('en-GB');

  constructor(private http: HttpClient) {}

  load(): Observable<ISignUpCountryCatalogue> {
    return this.http
      .get<ISignUpCountries>('/signup/countries')
      .pipe(map(response => this.toCatalogue(response)));
  }

  private toCatalogue(response: ISignUpCountries): ISignUpCountryCatalogue {
    const options = response.countries
      .map<ISignUpCountryOption>(country => ({
        code: country.code,
        name: this.names.of(country.code) ?? country.code
      }))
      .sort((one, other) => this.order.compare(one.name, other.name));

    const visitorCountry = options.some(option => option.code === response.visitorCountry)
      ? response.visitorCountry
      : null;

    return { options, visitorCountry };
  }
}
